export const fightcampSubscriptionYearly = {
  title: 'FightCamp 12-month Membership',
  id: 'fightcamp_subscription_yearly',
  price: 0,
  category: 'subscription',
  description: '',
  img_url: '',
};
